import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=3ffb5500&scoped=true&"
import script from "./Lottie.vue?vue&type=script&lang=js&"
export * from "./Lottie.vue?vue&type=script&lang=js&"
import style0 from "./Lottie.vue?vue&type=style&index=0&id=3ffb5500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb5500",
  null
  
)

export default component.exports